export enum TypesOfFatEnum {
  OIL = 'OIL',
  LARD = 'LARD'
}
